import { createSelector } from 'reselect';
import { ModuleType } from '../../types/modules';
import { ProfileSkin, officialSkins } from '../../types/profileSkins';
import { getModuleDataByModuleType } from './modules';

const getState = state => state.profileSkins;

export const getActiveSkin = createSelector([getState], state => {
  return state.activeSkin;
});

export const isSkinSelectorShown = state => getState(state).skinSelectorShown;

export const isSkinSaving = state => getState(state).isSkinSaving;

export const getProfileSkin = (state): ProfileSkin | undefined => {
  // active skin comes first when the selector is open
  const activeSkin = getActiveSkin(state);
  if (activeSkin && isSkinSelectorShown(state)) {
    return activeSkin;
  }

  // get the skin from the module config
  const moduleData = getModuleDataByModuleType(
    state,
    ModuleType.COVER_DEVIATION
  );
  if (!moduleData) {
    return undefined;
  }
  if (moduleData.profileSkin && moduleData.profileSkin.templateName) {
    const skin = officialSkins.find(
      s => s.skinId === moduleData.profileSkin.templateName
    );
    if (skin) {
      return skin;
    }
  }
  return undefined;
};
